module.exports = __webpack_public_path__ + "media/images/sales/early/eyecatch-problem-feea2bb313b46aef87f1dc9e6566f78a.png";